import {
  LitElement,
  html,
  css,
  t,
  classMap,
  range,
  map,
} from '@hh/global.js'


class HHMenuFeaturedContent extends LitElement {
  static get properties() {
    return {
      _current: { state: true },
      _total: { state: true },
    }
  }

  constructor() {
    super()
    this._current = 0
    this._total = 0
    this.items = []
    this.startX = 0
    this.endX = 0
    this.$carousel = null

    this._onTouchStart = this.onTouchStart.bind(this)
    this._onTouchEnd = this.onTouchEnd.bind(this)
  }

  firstUpdated() {
    this.items = Array.from(this.querySelectorAll('[slot="item"]'))
    this._total = this.items.length

    this.items.forEach((el, i) => {
      el.style.transition = 'opacity 300ms ease-in-out'
      el.style.opacity = i === this._current ? '1' : '0'
      el.style.pointerEvents = i === this._current ? 'auto' : 'none'
      el.style.position = i === this._current ? 'relative' : 'absolute'
      el.style.inset = '0'

      if (i === this._current) {
        el.addEventListener('touchstart', this._onTouchStart, { passive: true })
        el.addEventListener('touchend', this._onTouchEnd, { passive: true })
      }
    })

    this.$carousel = this.renderRoot.querySelector('.carousel')

    const maxHeight = Math.max(...this.items.map((el) => el.offsetHeight))
    this.$carousel.style.minHeight = `${maxHeight}px`
  }

  updated() {
    if (this.items.length) {
      requestAnimationFrame(() => {
        const maxHeight = Math.max(
          ...this.items.map((el) => el.getBoundingClientRect().height)
        )

        this.$carousel.style.minHeight = `${maxHeight}px`
        this._measuredHeight = true
      })
    }

    this.items.forEach((el, i) => {
      el.style.opacity = i === this._current ? '1' : '0'
      el.style.pointerEvents = i === this._current ? 'auto' : 'none'
      el.style.position = i === this._current ? 'relative' : 'absolute'

      if (i === this._current) {
        el.addEventListener('touchstart', this._onTouchStart, { passive: true })
        el.addEventListener('touchend', this._onTouchEnd, { passive: true })
      } else {
        el.removeEventListener('touchstart', this._onTouchStart)
        el.removeEventListener('touchend', this._onTouchEnd)
      }
    })
  }

  onTouchStart(e) {
    this.startX = e.changedTouches[0].clientX
  }

  goTo(idx) {
    if (idx === this._current) return
    this._current = idx
    this.updateComplete.then(() => {
      this.updated()
    })
  }

  onTouchEnd(e) {
    this.endX = e.changedTouches[0].clientX
    const deltaX = this.endX - this.startX

    if (Math.abs(deltaX) > 50) {
      if (deltaX < 0) {
        const next = (this._current + 1) % this._total
        this.goTo(next)
      } else {
        const prev = (this._current - 1 + this._total) % this._total
        this.goTo(prev)
      }
    }
  }

  render() {
    return html`
      <div class="container">
        <div class="carousel">
          <slot name="item"></slot>
        </div>
        <div class="${classMap({
      pagination: true,
      hide: this._total <= 1,
    })}">
          ${map(range(this._total), (idx) => {
      return html`
              <button
                class="dot"
                aria-label="${t('accessibility.go_to_slide', 'Slide')} ${idx + 1}"
                aria-current="${this._current === idx ? 'true' : 'false'}"
                ?disabled="${this._current === idx}"
                @click="${() => this.goTo(idx)}"
              >
                <span class="dot__inner"></span>
              </button>
            `
    })}
        </div>
      </div>
    `
  }

  static get styles() {
    return css`
      .container {
        position: relative;
        width: 100%;
      }

      .carousel {
        position: relative;
        width: 100%;
        overflow: hidden;
      }

      ::slotted([slot='item']) {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .pagination {
        position: absolute;
        top: calc(100vw * 0.6385 - 28px);
        right: 16px;
        display: flex;
        align-items: center;
        gap: 4px;
        z-index: 0;
      }

      .dot {
        all: unset;
        cursor: pointer;
      }

      .dot__inner {
        display: block;
        height: 10px;
        width: 10px;
        border-radius: 100%;
        border: 1px solid #FFFFFF;
        transition: all 300ms ease-in-out;
      }

      .dot[aria-current='true'] .dot__inner {
        background: var(--hh-color-day);
      }
    `
  }
}

customElements.define('hh-menu-featured-content', HHMenuFeaturedContent)

